import {h, Component} from 'preact'
import {SignalLite} from 'signals-lite'
// wp_enqueue_script: jquery
import FontImage from './FontImage'
import loadScript from '../utils/load-script'
import classnames from '../utils/classnames'
// global: products

export function invokeBuyingOptions (product) {
  modalInvoked.broadcast(product)
}
export function closeBuyingOptions () {
  modalDismissed.broadcast()
}

const modalInvoked = new SignalLite()
const modalDismissed = new SignalLite()

export default class BuyingOptions extends Component {
  state = {
    visible: false,
    font: null,
    displayFontID: null,
    selectedDesktopLicense: '',
    selectedWebfontLicense: '',
    selectedAppLicense: '',
    selectedEpubLicense: '',
    addToCartDisabled: false,
    addToCartUIDisabled: false
  }

  disableAddToCart = () => {
    const timeoutID = setTimeout(() => {
      this.setState({ addToCartUIDisabled: true })
    }, 250)
    this.setState({ addToCartDisabled: timeoutID })
  }
  enableAddToCart = () => {
    clearTimeout(this.state.addToCartDisabled)
    this.setState({
      addToCartDisabled: false,
      addToCartUIDisabled: false
    })
  }

  componentDidMount () {
    modalInvoked.add(this.handleInvoked)
    modalDismissed.add(this.handleDismissed)
  }
  componentWillUnmount () {
    modalInvoked.remove(this.handleInvoked)
    modalDismissed.remove(this.handleDismissed)
  }

  handleInvoked = (font, displayFontID = null) => {
    this.setState({
      font,
      displayFontID,
      visible: true,
      selectedDesktopLicense: '',
      selectedWebfontLicense: '',
      selectedAppLicense: '',
      selectedEpubLicense: '',
      selectedMultisiteLicense: '',
      addToCartDisabled: false,
      addToCartUIDisabled: false
    })
  }
  handleDismissed = () => {
    this.setState({
      visible: false
    })
  }

  render () {
    const font = this.state.font
    const post = font && font.post
    const prices = font && font.prices
    const priceOptions = [<option value="">Select</option>]
    var app, appPrices, appPriceOptions = [<option value="">Select</option>]
    var epub, epubPrices, epubPriceOptions = [<option value="">Select</option>]
    var webfont, webfontPrices, webfontPriceOptions = [<option value="">Select</option>]
    var multisite, multisitePrices, multisitePriceOptions = [<option value="">Select</option>]

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });

    if (prices) {
      for (let key in prices) {
        const price = prices[key]
        priceOptions.push(<option key={key} value={key}>{price.name + ' - ' + formatter.format(price.amount)}</option>)
      }
    }

    if (post && products) {
      for (let id in products) {
        const product = products[id]
        let slug = products[id].post.post_name
        if (slug.indexOf(post.post_name + '-apps') === 0) {
          app = product.post
          appPrices = product.prices
          for (let key in appPrices) {
            const price = appPrices[key]
            appPriceOptions.push(<option key={key} value={key}>{price.name + ' - ' + formatter.format(price.amount)}</option>)
          }
        }
        else if (slug.indexOf(post.post_name + '-epubs') === 0) {
          epub = product.post
          epubPrices = product.prices
          for (let key in epubPrices) {
            const price = epubPrices[key]
            epubPriceOptions.push(<option key={key} value={key}>{price.name + ' - ' + formatter.format(price.amount)}</option>)
          }
        }
        else if (slug.indexOf(post.post_name + '-webfont') === 0) {
          webfont = product.post
          webfontPrices = product.prices
          for (let key in webfontPrices) {
            const price = webfontPrices[key]
            webfontPriceOptions.push(<option key={key} value={key}>{price.name + ' - ' + formatter.format(price.amount)}</option>)
          }
        }
        else if (slug.indexOf(post.post_name + '-multi-site') === 0) {
          multisite = product.post
          multisitePrices = product.prices
          for (let key in multisitePrices) {
            const price = multisitePrices[key]
            multisitePriceOptions.push(<option key={key} value={key}>{price.name + ' - ' + formatter.format(price.amount)}</option>)
          }
        }
      }
    }

    const {selectedDesktopLicense, selectedWebfontLicense, selectedEpubLicense, selectedAppLicense, selectedMultisiteLicense} = this.state

    if (this.state.visible) {
      return <div className="modal-container" onClick={this.handleCloseClick}>
      <div className="modal-box" onClick={this.handleBoxClick}>
        <header className="modal-header">
          <h1>Buying Options</h1>
          <div className="close-btn" onClick={this.handleCloseClick}>
            <svg width="14" height="14" viewBox="591 356 35 35">
              <path d="M625.1215,362.1215 L613.2425,374.0005 L625.1215,385.8785 C625.6635,386.4215 625.9995,387.1715 625.9995,387.9995 C625.9995,389.6575 624.6565,390.9995 622.9995,390.9995 C622.1715,390.9995 621.4215,390.6645 620.8785,390.1215 L608.9995,378.2425 L597.1215,390.1215 C596.5785,390.6645 595.8285,390.9995 594.9995,390.9995 C593.3435,390.9995 591.9995,389.6575 591.9995,387.9995 C591.9995,387.1715 592.3355,386.4215 592.8785,385.8785 L604.7575,374.0005 L592.8785,362.1215 C592.3355,361.5785 591.9995,360.8285 591.9995,359.9995 C591.9995,358.3435 593.3435,356.9995 594.9995,356.9995 C595.8285,356.9995 596.5785,357.3355 597.1215,357.8785 L608.9995,369.7575 L620.8785,357.8785 C621.4215,357.3355 622.1715,356.9995 622.9995,356.9995 C624.6565,356.9995 625.9995,358.3435 625.9995,359.9995 C625.9995,360.8285 625.6635,361.5785 625.1215,362.1215" stroke="none" fill="#ffb4af" fill-rule="evenodd"></path>
            </svg>
          </div>
        </header>
        <div className="modal-body">
          <div className="row-10 selection">
            <div className="column cols-2 offset-left-1 label">Your Selection</div>
            <div className="column cols-4 typeface-preview">
              {post && <FontImage id={post.ID} text={post.post_title} width="374" height="70" pointSize="20" paddingTop="24" />}
            </div>
            <div className="column cols-1 font-count">{
              (post && post.fields && post.fields.children && post.fields.children.length > 1)
                ? post.fields.children.length + ' Fonts'
                : (post.post_name.endsWith('collection'))
                  ? '1 Collection'
                  : '1 Font'
            }</div>
            <div className="column cols-2 top-cart-button">
              <a className={classnames('add-to-cart-button', this.state.addToCartUIDisabled && 'disabled')} href="#" onClick={this.handleAddToCartClick}>Add to Cart</a>
            </div>
          </div>
          <div className="row-10 licensing">
            <div className="column cols-2 offset-left-1 label">Choose Licensing</div>
            <div className="column cols-5 licenses">
              <div className="desktop license">
                <div className="icon">
                  <svg width="14" height="13" viewBox="514 356 34 32">
                    <path d="M516.143,377.3578 L545.072,377.3578 L545.072,359.1428 L516.143,359.1428 L516.143,377.3578 Z M545.608,381.6438 L537.572,381.6438 L535.429,381.6438 L535.429,384.3228 L537.572,386.4648 L537.572,387.0008 L523.643,387.0008 L523.643,386.4648 L525.786,384.3228 L525.786,381.6438 L523.643,381.6438 L515.607,381.6438 C514.72,381.6438 514,380.9238 514,380.0368 L514,358.6078 C514,357.7198 514.72,356.9998 515.607,356.9998 L545.608,356.9998 C546.495,356.9998 547.215,357.7198 547.215,358.6078 L547.215,380.0368 C547.215,380.9238 546.495,381.6438 545.608,381.6438 L545.608,381.6438 Z" id="Page-1" stroke="none" fill="#000000" fill-rule="evenodd"></path>
                  </svg>
                </div>
                <div className="label">
                  <label for="desktop-options">{
                    (post && post.post_name && post.post_name.indexOf('clearviewhwy') !== -1)
                      ? 'Singlesite License'
                      : 'Desktop License'
                  }</label>
                  <a href="/licensing">View license</a></div>
                <div className="options"><select disabled={this.state.addToCartDisabled} id="desktop-options" onChange={this.handleDesktopChange}>{priceOptions}</select></div>
                <div className="price">{
                  selectedDesktopLicense && formatter.format(prices[selectedDesktopLicense].amount)
                }</div>
              </div>
              { webfontPriceOptions.length > 1 &&
              <div className="webfont license">
                <div className="icon" style="line-height: 16px;"><strong style="font-size: 10px;">&lt;/&gt;</strong></div>
                <div className="label">
                  <label for="webfont-options">Webfont License</label>
                  <a href="/licensing">View license</a></div>
                <div className="options"><select disabled={this.state.addToCartDisabled} id="webfont-options" onChange={this.handleWebfontChange}>{webfontPriceOptions}</select></div>
                <div className="price">{
                  selectedWebfontLicense && formatter.format(webfontPrices[selectedWebfontLicense].amount)
                }</div>
              </div>
              }
              {appPriceOptions.length > 1 &&
              <div className="app license">
                <div className="icon">
                  <div style="border: 2px solid black; border-radius: 3px; padding: 1px; display: inline-block;"><img src="data:image/gif;base64,R0lGODlhBgAGAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5N0UyRkQ3OTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5N0UyRkQ3QTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk3RTJGRDc3MTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjk3RTJGRDc4MTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAAAAAAAsAAAAAAYABgAAAgoEEmaol45YfM4UADs="
                    width="6" height="6" style="display: block" /></div>
                </div>
                <div className="label">
                  <label for="app-options">App License</label>
                  <a href="/licensing">View license</a></div>
                <div className="options"><select disabled={this.state.addToCartDisabled} id="app-options" onChange={this.handleAppChange}>{appPriceOptions}</select></div>
                <div className="price">{
                  selectedAppLicense && formatter.format(appPrices[selectedAppLicense].amount)
                }</div>
              </div>
              }
              {epubPriceOptions.length > 1 &&
              <div className="Epub license">
                <div className="icon"><div style="display: inline-block">
                  <img src="data:image/gif;base64,R0lGODlhCgANAIAAAAEBAf///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5N0UyRkQ3RDEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5N0UyRkQ3RTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk3RTJGRDdCMTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjk3RTJGRDdDMTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAAAAAAAsAAAAAAoADQAAAheEjxDLa5HUa+xFqKiTCeuNTd4nUtGJFgA7"
                    width="10" height="13" style="display: block; image-rendering: pixelated" />
                </div></div>
                <div className="label">
                  <label for="epub-options">Epub License</label>
                  <a href="/licensing">View license</a></div>
                <div className="options"><select disabled={this.state.addToCartDisabled} id="epub-options" onChange={this.handleEpubChange}>{epubPriceOptions}</select></div>
                <div className="price">{
                  selectedEpubLicense && formatter.format(epubPrices[selectedEpubLicense].amount)
                }</div>
              </div>
              }
              {multisitePriceOptions.length > 1 &&
              <div className="multisite license">
                <div className="icon">
                  <svg width="14" height="13" viewBox="514 356 34 32">
                    <path d="M516.143,377.3578 L545.072,377.3578 L545.072,359.1428 L516.143,359.1428 L516.143,377.3578 Z M545.608,381.6438 L537.572,381.6438 L535.429,381.6438 L535.429,384.3228 L537.572,386.4648 L537.572,387.0008 L523.643,387.0008 L523.643,386.4648 L525.786,384.3228 L525.786,381.6438 L523.643,381.6438 L515.607,381.6438 C514.72,381.6438 514,380.9238 514,380.0368 L514,358.6078 C514,357.7198 514.72,356.9998 515.607,356.9998 L545.608,356.9998 C546.495,356.9998 547.215,357.7198 547.215,358.6078 L547.215,380.0368 C547.215,380.9238 546.495,381.6438 545.608,381.6438 L545.608,381.6438 Z" id="Page-1" stroke="none" fill="#000000" fill-rule="evenodd"></path>
                  </svg>
                </div>
                <div className="label">
                  <label for="multisite-options">Multisite License</label>
                  <a href="/licensing">View license</a></div>
                <div className="options"><select disabled={this.state.addToCartDisabled} id="multisite-options" onChange={this.handleMultisiteChange}>{multisitePriceOptions}</select></div>
                <div className="price">{
                  selectedMultisiteLicense && formatter.format(multisitePrices[selectedMultisiteLicense].amount)
                }</div>
              </div>
              }
            </div>
          </div>
          <div className="row-10 total">
            <div className="column cols-2 offset-left-3">Total</div>
            <div className="column cols-3 price">{formatter.format(
                (selectedDesktopLicense   ? parseFloat(prices         [selectedDesktopLicense  ].amount) : 0)
              + (selectedWebfontLicense   ? parseFloat(webfontPrices  [selectedWebfontLicense  ].amount) : 0)
              + (selectedEpubLicense      ? parseFloat(epubPrices     [selectedEpubLicense     ].amount) : 0)
              + (selectedAppLicense       ? parseFloat(appPrices      [selectedAppLicense      ].amount) : 0)
              + (selectedMultisiteLicense ? parseFloat(multisitePrices[selectedMultisiteLicense].amount) : 0)
            )}</div>
          </div>
          <div className="checkout">
            <a className={classnames('add-to-cart-button', this.state.addToCartUIDisabled && 'disabled')} href="#" onClick={this.handleAddToCartClick}>Add to Cart</a>
          </div>
        </div>
        <footer>
          <div className="left">
            <p>Sales Tax of 8.875% is collected <br />
              for New York State residents.</p>
            <p>Buy fonts with a <a href="/contact">Purchase Order</a></p>
          </div>
          <div className="middle">
            <p>Once fonts have been downloaded<br />
            no refunds will be given.</p>
          </div>
          <div className="right">
            <p>Questions?<br />
              <a href="/contact">Please Contact Us.</a></p>
          </div>
        </footer>
      </div>
    </div>
    } else {
      return null
    }
  }

  handleBoxClick = (event) => {
    event.stopPropagation()
  }
  handleCloseClick = (event) => {
    closeBuyingOptions()
  }

  handleDesktopChange = (event) => {
    this.setState({ selectedDesktopLicense: event.target.value })
  }
  handleWebfontChange = (event) => {
    this.setState({ selectedWebfontLicense: event.target.value })
  }
  handleAppChange = (event) => {
    this.setState({ selectedAppLicense: event.target.value })
  }
  handleEpubChange = (event) => {
    this.setState({ selectedEpubLicense: event.target.value })
  }
  handleMultisiteChange = (event) => {
    this.setState({ selectedMultisiteLicense: event.target.value })
  }

  handleAddToCartClick = (event) => {
    event.preventDefault()
    if (this.state.addToCartDisabled) return
    if (!this.state.font) return

    const {selectedDesktopLicense, selectedWebfontLicense, selectedEpubLicense, selectedAppLicense, selectedMultisiteLicense} = this.state
    if (!(selectedDesktopLicense || selectedWebfontLicense || selectedEpubLicense || selectedAppLicense || selectedMultisiteLicense)) return

    // don't allow a second submit
    this.disableAddToCart()

    const post = this.state.font.post
    const queue = []
    if (selectedDesktopLicense) {
      queue.push(getAddToCartData(post.ID, selectedDesktopLicense,products[post.ID].nonce))
    }
    for (let id in products) {
      const product = products[id]
      let slug = products[id].post.post_name
      if (selectedWebfontLicense && slug.indexOf(post.post_name + '-webfont') === 0) {
        queue.push(getAddToCartData(id, selectedWebfontLicense,products[id].nonce))
      }
      if (selectedAppLicense && slug.indexOf(post.post_name + '-apps') === 0) {
        queue.push(getAddToCartData(id, selectedAppLicense,products[id].nonce))
      }
      if (selectedEpubLicense && slug.indexOf(post.post_name + '-epubs') === 0) {
        queue.push(getAddToCartData(id, selectedEpubLicense,products[id].nonce))
      }
      if (selectedMultisiteLicense && slug.indexOf(post.post_name + '-multi-site') === 0) {
        queue.push(getAddToCartData(id, selectedMultisiteLicense,products[id].nonce))
      }
    }
    var i = 0
    const loopReq = () => {
      i++
      if (i < queue.length) {
        doCartRequest(queue[i], loopReq)
      } else {
        // this.enableAddToCart()
        window.location = '/cart'
      }
    }
    doCartRequest(queue[i], loopReq)
  }
}

function getAddToCartData (download_id, option, nonce) {
  return {
    action: 'edd_add_to_cart',
    'price_ids%5B%5D': option,
    download_id: download_id,
    nonce: nonce,
  }
}
function doCartRequest (params, cb) {
  const req = new Request('/wp-admin/admin-ajax.php')

  const body = []
  for (let key in params) {
    body.push(key + '=' + params[key])
  }

  fetch(req, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    credentials: 'include',
    redirect: 'manual',
    body: body.join('&')
  })
  .then(
    response => {
      cb(response)
    }, error => {
      console.error(error)
    }
  )
}

// polyfill: https://philipwalton.com/articles/loading-polyfills-only-when-needed/
function hasAllPolyfills () {
  return window.Intl && window.fetch
}
if (!hasAllPolyfills()) {
  loadScript('https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl,fetch')
}



// WEBPACK FOOTER //
// ./inc/js/components/BuyingOptions.js